<ui-table [responsive]="false" [rows]="shoppingLists()">
  <div name="name" uiTableColumn>
    <ng-template uiTableHeader>
      Name
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      <a (click)="showDetailsClicked(item.id)">{{ item.name }}</a>
    </ng-template>
  </div>
  <div name="owner" uiTableColumn>
    <ng-template uiTableHeader>
      Eigentümer
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      {{ item.owner }}
    </ng-template>
  </div>
  <div name="created-at" uiTableColumn>
    <ng-template uiTableHeader>
      Erstelldatum
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      {{ item.createdAt | luxonDate }}
    </ng-template>
  </div>
  <div name="items-count" uiTableColumn>
    <ng-template uiTableHeader>
      Artikelanzahl
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      <span class="items-count">
        {{ item.itemCount }} Positionen
      </span>
    </ng-template>
  </div>
  <div name="actions" uiTableColumn>
    <ng-template uiTableHeader>
      <div class="has-actions-th">
        Aktionen
      </div>
    </ng-template>
    <ng-template let-item="item" uiTableCell>
      <ui-shopping-list-actions
        [shoppingList]="item"
        class="has-actions"
      ></ui-shopping-list-actions>
    </ng-template>
  </div>
</ui-table>
